import { PRODUCT_KEYS } from '../../common/productKeys/ProductKeys';
import {
  generateUniqueId,
  getLocalStorage,
  toBase64,
} from '../../common/Utils/Utils';
const token = getLocalStorage('token');
export const requestConfigMap = {
  [PRODUCT_KEYS.PASSPORT_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ frontImage, backImage, activeTab }) => {
      const selectedFile = activeTab === 'front' ? frontImage : backImage;

      return {
        recordId: generateUniqueId(),
        image: await toBase64(selectedFile),
        face_image_required: false,
      };
    },
    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },
  [PRODUCT_KEYS.AADHAAR_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ frontImage, backImage, activeTab }) => {
      const selectedFile = activeTab === 'front' ? frontImage : backImage;

      return {
        recordId: generateUniqueId(),
        image: await toBase64(selectedFile),
        face_image_required: false,
      };
    },
    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.EMIRATES_ID_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ frontImage, backImage, activeTab }) => {
      const selectedFile = activeTab === 'front' ? frontImage : backImage;

      return {
        recordId: generateUniqueId(),
        image: await toBase64(selectedFile),
      };
    },
    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.PAN_CARD_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ selectedFile }) => ({
      recordId: generateUniqueId(),
      image: await toBase64(selectedFile),
      face_image_required: false,
      sign_image_required: false,
      pan_image_required: false,
    }),

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.AADHAAR_MASK]: {
    method: 'POST',
    buildRequestBody: async ({ selectedFile }) => ({
      image_uuid: generateUniqueId(),
      aadhar_image: await toBase64(selectedFile),
      image_format: '',
      pdf_out: false,
      detection_based_masking: false,
      // retrieve_last_four_digits_of_aadhar: true,
    }),

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.VOTER_ID_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ frontImage, backImage, activeTab }) => {
      const selectedFile = activeTab === 'front' ? frontImage : backImage;

      return {
        recordId: generateUniqueId(),
        image: await toBase64(selectedFile),
      };
    },

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.MALAYSIAN_VOTER_ID_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ selectedFile }) => ({
      recordId: generateUniqueId(),
      image: await toBase64(selectedFile),
    }),

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.MALAYSIAN_DRIVING_LICENSE_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ selectedFile }) => ({
      recordId: generateUniqueId(),
      image: await toBase64(selectedFile),
    }),

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.MEXICAN_ID_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ frontImage, backImage, activeTab }) => {
      const selectedFile = activeTab === 'front' ? frontImage : backImage;

      return {
        recordId: generateUniqueId(),
        image: await toBase64(selectedFile),
      };
    },

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },

  [PRODUCT_KEYS.UAE_VISA_OCR]: {
    method: 'POST',
    buildRequestBody: async ({ selectedFile }) => ({
      recordId: generateUniqueId(),
      image: await toBase64(selectedFile),
    }),

    getHeaders: ({ currentProduct }) => ({
      'Content-Type': 'application/json',
      key: currentProduct?.clientKey,
    }),
  },
};
